class BESSAppProjectsHeader extends BESSAppBase {

    constructor(owner) {
        super();
        this.owner = owner;
        this.node = $('.app-projects-header');
        this.searchInput = this.node.find('.app-search-projects-input');
        this.siteTypesSelect = this.node.find('.app-project-site-types-select');
        this.councilSelect = this.node.find('.app-project-council-select');
        this.engineSelect = this.node.find('.app-project-engine-select');
        this.scoreSelect = this.node.find('.app-project-score-select');
        this.sortSelect = this.node.find('.app-project-sort-select');
        this.export = this.node.find('.app-export');
        this.export.bindClickEvent(this, this.#onExport);
        this.mobileFiltersModal = new BESSAppProjectsMobileFiltersModal();
        this.mobileFiltersApply = this.mobileFiltersModal.view.node.find('.app-done');
        this.mobileFiltersApply.bindClickEvent(this, this.#onAppleMobileFilters);
        this.mobileFiltersTrigger = this.node.find('.app-mobile-filters');
        this.mobileFiltersTrigger.bindClickEvent(this, function () {
            this.#initialiseMobileFilters();
            this.mobileFiltersModal.open();
        });

        this.searchInput.onTypeAheadChange(this.owner, this.owner.reloadProjects);
        this.siteTypesSelect.onChangeKeyUp(this.owner, this.owner.reloadProjects);
        this.councilSelect.onChangeKeyUp(this.owner, this.owner.reloadProjects);
        this.engineSelect.onChangeKeyUp(this.owner, this.owner.reloadProjects);
        this.scoreSelect.onChangeKeyUp(this.owner, this.owner.reloadProjects);
        this.sortSelect.onChangeKeyUp(this.owner, this.owner.reloadProjects);

        this.projectsCount = $('.app-projects-count');
    }

    #initialiseMobileFilters() {
        let container = this.mobileFiltersModal.view.body.find('.filters');
        container.empty();
        this.forEach([this.searchInput,
            this.siteTypesSelect,
            this.engineSelect,
            this.scoreSelect], function (view) {
            let clone = view.clone();
            container.append(clone);
            let pageInputVal = view.val();
            if (pageInputVal == null) {
                pageInputVal = '';
            }
            clone.val(pageInputVal);
        });
    }

    #onAppleMobileFilters() {
        let container = this.mobileFiltersModal.view.body.find('.filters');
        this.forEach([
            '.app-search-projects-input',
            '.app-project-site-types-select',
            '.app-project-council-select',
            '.app-project-engine-select',
            '.app-project-score-select'
        ], function (selector) {
            let mobileInput = container.find(selector);
            let pageInput = this.node.find(selector);
            let mobileInputVal = mobileInput.val();
            if (mobileInputVal == null) {
                mobileInputVal = '0';
            }
            this.log("apply", {
                'selector': selector,
                'val': mobileInput.val(),
                'mobileInputVal': mobileInputVal,
            })
            pageInput.val(mobileInputVal);
        });
        this.owner.reloadProjects();
        this.mobileFiltersModal.close();
    }

    updateProjectsCount(countNode) {
        this.projectsCount.replaceWith(countNode);
        this.projectsCount = $('.app-projects-count');
    }

    selectOption(field, value) {
        field.val(value);
        field.parent().addClassIf('option-selected', value !== '0');
    }

    #onExport() {
        this.export.find('span').hide();
        this.export.find('.app-spinner').show();

        window.location.href = window.location + '&export=1'
        setTimeout(function () {
            this.export.find('span').show();
            this.export.find('.app-spinner').hide();
        }.bind(this), 5000);
    }

}

class BESSAppProjectsMobileFiltersModal extends BESSAppModal {

    constructor() {
        super('app-projects-mobile-filters-modal');
    }
}